import React, { useState, useEffect } from 'react';
import '../../styles/main.scss';
import api from '../../services/api';
import Notification from '../common/Notification';
import Authorization from '../common/Authorization';
import { useAuth } from '../../AuthContext';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);  
  const [notification, setNotification] = useState(null);
  const { login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('username');
    localStorage.removeItem('licenseKey');
    localStorage.removeItem('accessToken');
    sessionStorage.clear();
}, []);


  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // const data = await api.auth.login({ username: email, password });
    
      localStorage.setItem('username', "Optisol@yopmail.com");
      localStorage.setItem('accessToken', "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoiT3B0aXNvbEB5b3BtYWlsLmNvbSIsImp0aSI6IjBkZDhkZTRjLTIzOGMtNGMxYS1hMjdmLWFmZjc4MTI1Zjk1ZSIsIk9yZ0lkIjoiNSIsImV4cCI6MTc2NDE2MzUzMywiaXNzIjoiaHR0cDovL3lvdXJkb21haW4uY29tIiwiYXVkIjoiaHR0cDovL3lvdXJkb21haW4uY29tIn0.XdDBVeUoraEh-JCTL3IgOaZtii0jPTpMfZXXFvOYpBo");
      localStorage.setItem('licenseKey', "553b7b9e3e2917c1c9aa03b61dd6d27ba13ba782");
    
      login();
      navigate('/pb-conversion');
    } catch (error) {
      setNotification({
        message: `Login failed: ${error.message}`,
        type: 'error',
      });
    }
  };

  return (
    <div className="flex flex-col md:flex-row min-h-screen">
      <Authorization/>

      {/* Right side */}
      <div className="w-full md:w-1/2 flex items-center justify-center py-10 px-4 md:px-0">
        <div className="w-full max-w-md">
          <h2 className="text-2xl md:text-3xl font-bold mb-6 primary-heading px-0">Login</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email</label>
              <input
                type="text"
                id="email"
                className="mt-1 block w-full rounded-md custom-form-input focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
              />
            </div>
            <div className="mb-6">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700">Password</label>
              <div className="relative">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  className="mt-1 block w-full rounded-md custom-form-input focus:border-blue-300 focus:ring focus:ring-blue-200 focus:ring-opacity-50"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
                <button
                  type="button"
                  className="absolute inset-y-0 right-0 pr-3 flex items-center text-sm leading-5"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <svg className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                  ) : (
                    <svg className="h-6 w-6 text-gray-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858.908a3 3 0 114.243 4.243M9.878 9.878l4.242 4.242M3 3l3.59 3.59m0 0A9.953 9.953 0 0112 5c4.478 0 8.268 2.943 9.543 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21" />
                    </svg>
                  )}
                </button>
              </div>
            </div>
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-4">
              <button
                type="submit"
                className="btn-blue-color text-white font-bold py-2 px-4 rounded-[10px] focus:outline-none focus:shadow-outline w-full md:w-auto"
              >
                Login
              </button>
              <span className='gray-link-colour'>
                Don't have an account?
                <a href="/signup" className="mx-2 text-blue-600 hover:text-blue-800">Sign up here</a>
              </span>
            </div>
            <a href="/forgotpassword" className="mx-2 text-blue-600 hover:text-blue-800">Forgot Password?</a>

            {/* <button
                type="button"
                className="font-bold py-2 px-0 mx-2 my-2 text-blue-600 hover:text-blue-800 focus:outline-none focus:shadow-outline w-full md:w-auto"
                onClick={handleForgetPassword}
              >
                Forgot Password?
              </button> */}
          </form>
        </div>
      </div>

      {/* Notification */}
      {notification && (
        <Notification
          message={notification.message}
          type={notification.type}
          onClose={() => setNotification(null)}
        />
      )}
    </div>
  );
};

export default Login;